import Usuario from "../../models/Usuario";

const INITIAL_STATE = Usuario.model;

export default function usuario(state = INITIAL_STATE, action){
  if(action.type === "SET_USUARIO")
    return action.usuario;
  return state;
}